<template>
  <div>
    <template v-if="loading">
      <div class="ui-loading">
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
      </div>
    </template>
    <template v-else-if="!loading && documents.length">
      <div class="header">
        <button
          class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect button--colored-gradient-primary"
          @click="addDocument = true"
        ><i class="material-icons">cloud_upload</i>
        <span>Upload Files</span>
        </button>
      </div>
      <h3 v-text="$route.meta.title"></h3>
      <div class="documents-layout__actions">
        <form action="#">
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="text" id="search" v-model="searchString" @input="searchDocuments">
            <label class="mdl-textfield__label" for="search">Search files and folders</label>
          </div>
        </form>
      <div>
        <div class="d--flex">
          <p>Show per page: </p>
          <v-select
            v-model="limit"
            dir="ltr"
            :options="paginationOptions"
            @input="getDocuments"
          >
          </v-select>
        </div>
        <pagination
          v-if="pagination && pagination.totalPages > 1"
          class="pull--right"
          :pagination="pagination"
          :searchTerm="searchString"
          @changePage="changePage"
        >
        </pagination>
      </div>
      </div>
      <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
        <thead>
          <tr>
            <th
              v-for="(heading, key) in tableHeadings"
              v-text="heading"
              :key="key"
              class="mdl-data-table__cell--non-numeric"
            >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(doc, index) in documents" :key="index">
            <td
              class="mdl-data-table__cell--non-numeric"
              v-for="(heading, key) in tableHeadings"
              :key="key"
            >
            <span v-if="heading !== 'actions' && heading !== 'read'" v-text="doc[heading]"></span>
            <span v-else-if="heading === 'read'">
              <i
                v-if="doc.read"
                class="material-icons clickable unselectable"
                :class="{'read': doc.read}"
                style=" user-select: none"
                @click="toggleDocumentRead(doc)"
              >
                check_circle_outline
              </i>
              <i
                v-else
                class="material-icons clickable unselectable faded-icon doc-action"
                @click="toggleDocumentRead(doc)"
              >
                highlight_off
              </i>
            </span>
            <span v-else>
              <span
                v-for="(action, index) in doc.actions"
                :key="index"
                class="doc-action"
                @click="doIconAction(action.type, doc)"
              >
                <i
                  v-if="$store.getters.user.group_id !== doc.relatedId || ($store.getters.user.group_id === doc.relatedId && action.type == 'download')"
                  class="material-icons"
                >
                {{ action.icon }}
              </i>
              </span>
            </span>
            </td>
          </tr>
        </tbody>
      </table>
      <confirm-delete
        v-if="confirmDelete"
        :document="activeDocument"
        @delete="deleteDocument"
        @close="closeConfirmDelete"
      >
      </confirm-delete>
      <share
        v-if="shareDocument"
        @close="closeShareDocument"
        :documentId="activeDocument.dbDocumentId"
      />
      <add-document
        v-if="addDocument"
        @close="addDocument = false"
        @fileUploadSuccess="fileUploadSuccess"
      />
    </template>
    <template v-else>
      <div class="empty-documents">
        <div
          class="empty-documents__icon-wrapper"
          @click="addDocument = true"
        >
          <empty-document-icon class="empty-documents__icon-wrapper__icon" />
        </div>
        <div class="empty-documents__content">
          <h5 v-text="'Upload your documents'"></h5>
        </div>
      </div>
      <add-document v-if="addDocument" @close="addDocument = false" @fileUploadSuccess="fileUploadSuccess" />
    </template>
  </div>
</template>
<script>
import confirmDelete from '../components/ConfirmDelete'
import addDocument from '../components/AddDocument'
import share from '../components/Share'
import emptyDocumentIcon from '../components/EmptyDocumentIcon'
import pagination from '../components/Pagination'
import vSelect from 'vue-select'

export default {
  components: {
    confirmDelete,
    addDocument,
    share,
    emptyDocumentIcon,
    pagination,
    vSelect
  },
  name: 'home',
  data: () => ({
    documents: [],
    searchString: '',
    activeDocument: null,
    addDocument: false,
    confirmDelete: false,
    shareDocument: false,
    loading: false,
    currentPage: 0,
    limit: 15,
    pagination: null,
    allowedKeys: [
      'name',
      'lastUpdated',
      'read',
      'expiry',
      'actions'
    ]
  }),
  computed: {
    tableHeadings () {
      return Object.keys(this.documents[0]).filter(doc => {
        return this.allowedKeys.includes(doc)
      })
    },
    paginationOptions () {
      if (this.pagination.totalDocuments > 100) {
        return [
          Math.ceil((this.pagination.totalDocuments / 100) * 20),
          Math.ceil((this.pagination.totalDocuments / 100) * 30),
          Math.ceil((this.pagination.totalDocuments / 100) * 40),
          Math.ceil((this.pagination.totalDocuments / 100) * 50)
        ]
      }

      return [
        Math.ceil((this.pagination.totalDocuments / 100) * 20),
        Math.ceil((this.pagination.totalDocuments / 100) * 40),
        Math.ceil((this.pagination.totalDocuments / 100) * 60),
        Math.ceil((this.pagination.totalDocuments / 100) * 80)
      ]
    }
  },
  methods: {
    searchDocuments () {
      this.documents.map(item => {
        item.active = false
        if (item.name.toLowerCase().includes(this.searchString.toLowerCase())) {
          item.active = ((!this.documentIsExpired(item) && item.relatedId === this.$store.getters.user.group_id) || item.relatedId === this.$store.getters.user.id)
        }
        return item
      })
    },
    documentIsExpired (document) {
      if (!document.expiry || document.expiry === '0000-00-00 00:00:00') {
        return false
      }

      let YMDhms = document.expiry.replace(/:| /g, '-').split('-')
      let date = new Date().setFullYear(parseInt(YMDhms[0]), parseInt(YMDhms[1]) - 1, parseInt(YMDhms[2]))
      date.setHours(parseInt(YMDhms[3]), parseInt(YMDhms[4]), parseInt(YMDhms[5]), 0)
      let now = new Date()

      if (now.getTime() > date.getTime()) {
        return true
      }

      return false
    },
    toggleDocumentRead (document) {
      document.read = (document.read === null) ? 1 : !document.read
      window.axios.put('/files/toggle-read-status/all/' + document.dbDocumentId + '/' + this.$store.getters.user.id, {
        read: document.read
      })
    },
    getDocuments () {
      this.documents = []
      this.loading = true
      let params = {}

      if (this.$route.meta.requestParams) {
        for (let i in this.$route.meta.requestParams) {
          let param = this.$route.meta.requestParams[i]
          let paramChunks = param.split('.')

          if (paramChunks.length > 1) {
            let obj = null
            for (let p in paramChunks) {
              obj = (obj) ? obj[paramChunks[p]] : this[paramChunks[p]]
            }
            params[i] = obj
          } else {
            params[i] = this[param]
          }
        }
      }

      window.axios.get(`${this.$route.meta.endpoint}`, {
        params
      }).then(response => {
        this.pagination = response.data.pagination
        for (let i = 0; i < response.data.data.length; i++) {
          let document = response.data.data[i]
          this.documents.push({
            relatedId: document.related_id,
            name: document.name.replace(/\+/g, ' ').split('.')[0],
            nameOnDisk: document.name,
            dbDocumentId: document.document_id,
            lastUpdated: (document.updatedDt) ? document.updatedDt.replace('T', ' ').split('.')[0] : null,
            bucketKey: document.s3_file_key.replace(/\+/g, ' '),
            readDeadline: '',
            read: document.read,
            active: true,
            expiry: document.expiry,
            actions: [
              {
                type: 'download',
                icon: 'cloud_download',
                showOnGroup: true
              },
              {
                type: 'share',
                icon: 'share',
                showOnGroup: false
              },
              {
                type: 'delete',
                icon: 'delete',
                showOnGroup: false
              }
            ]
          })
        }
        this.loading = false
      })
    },
    doIconAction (type, document) {
      switch (type) {
        case 'download':
          this.$root.snackbarText = 'Retrieving a secure download link...'
          this.$root.showSnackbar = true
          window.axios.get('/files/get-presigned-download-url/document-spaces/' + document.bucketKey.split('/')[1].replace(/\+/g, ' ') + '/' + document.bucketKey.split('/')[0]).then((response) => {
            this.$root.snackbarText = ''
            this.$root.showSnackbar = false
            window.open(response.data)
          })
          break
        case 'share':
          this.shareDocument = true
          this.activeDocument = document
          break
        case 'delete':
          this.activeDocument = document
          this.confirmDelete = true
          break
        default:
          break
      }
    },
    deleteDocument (documentId) {
      this.$root.snackbarText = 'Securely deleting the document...'
      this.$root.showSnackbar = true
      let nowTime = new Date().toISOString().slice(0, 19).replace('T', ' ')
      this.confirmDelete = false
      this.activeDocument = null
      window.axios.put('/expiry/add-document-expiry/' + documentId, { expiry: nowTime }).then((response) => {
        this.getDocuments()
      })
    },
    fileUploadSuccess () {
      this.addDocument = false
      this.getDocuments()
    },
    closeConfirmDelete () {
      this.confirmDelete = false
      this.activeDocument = null
    },
    closeShareDocument () {
      this.shareDocument = false
      this.activeDocument = null
    },
    changePage (page, searchString) {
      this.currentPage = page
      this.$router.replace({
        query: {
          page: this.currentPage,
          limit: this.limit
        }
      }, () => {
        (searchString) ? this.search() : this.getDocuments()
      })
    }
  },
  mounted () {
    this.currentPage = this.$route.query.page || 1
    this.limit = this.$route.query.limit || this.limit
    this.getDocuments()
    this.$nextTick(() => {
      this.componentHandler()
    })
  }
}
</script>
